<template>
    <div>
      <p class="ArticleNormal">
        喜欢抖音的， 不只有数量庞大的新潮年轻人，还有很多目的地城市。
      </p>
      <p class="ArticleNormal">
        当前国内疫情受控局势较好，文旅行业、城市的复苏也开始进入下半场关键期，客流的竞夺、消费的促进提升，人与资源的竞争，叠加城市早有的竞争驱动力，塑造出当前城市竞争更急迫、更复杂的情境。
      </p>
      <p class="ArticleNormal">
        城市营销、城市品牌形象与打造，被推至一个更高层级。
      </p>
      <p class="ArticleNormal">
        而城市营销的渠道、路径与模式等，相较以往也已有重塑态势，主要表现在以抖音为代表的短视频平台，凭借巨量的用户、分发推荐机制以及消费落地转化等链条构建，已较广泛渗透到城市营销市场格局中。短视频+城市营销，成为诸多城市寻求再塑城市品牌形象的重要模式。
      </p>
      <img src="../../../assets/1st/Articles/Article_12/contant_1.jpg"/>
      <p class="ArticleNormal">
        城市的身段更“绵柔”，更具人格化，它们要在短视频带来的城市营销新渠道、新路径，以及新的营销场景或场域中，找到中意的目标人群，争得他们的闲暇时间，讲述他们爱听的故事、展示他们爱看的风景，进而影响他们的心智。
      </p>
      <p class="ArticleNormal">
        城市营销的话语体系、内容与策略等也因此而变。
      </p>
      <p class="ArticleNormal">
        有不少城市或艳羡“网红城市”的耀眼荣光，或惊诧于“网红”消逝的迅疾，它们的疑问是自己到底该怎么做？
      </p>
      <p class="ArticleNormal">
        时也，势也，以文旅营销为前置对象之一的目的地城市营销，正面对新的主流客群、新的时代语境，这是它们竞争突围的新机遇期和新挑战期，如何“玩新”，如何进一步深掘城市文化等内核特质，锻造软实力？
      </p>
      <p class="ArticleHead">
        疫后城市营销竞夺战“痛感”加剧
      </p>
      <p class="ArticleNormal">
        疫情下，不少城市面临着前所未有的境况：人们出行自由度及收入等制约下，消费受制，城市的真正复苏还要一个较长过程；同时，国外疫情的反复和高发态势，以及其他因素影响，使得拉动内需、新项目引进投建，形成一定的经济内循环效应，被抬升至更高的层面。
      </p>
      <p class="ArticleNormal">
        以一省、一市来说，其不仅要寻求本省（市）消费、项目建设的有效激发，还需要形成对本省（市）之外客流、商流和钱流的有效吸引。
      </p>
      <p class="ArticleNormal">
        由此，城市间的引流营销竞争加剧，但当前“痛感”也明显。
      </p>
      <p class="ArticleNormal">
        不少城市的营销思维、营销方式及渠道等相对传统，营销内容与方式年轻化、移动化和短视频化的程度还不够，比如对抖音这类短视频应用平台，不少城市城市品牌操盘手，也知其“利器”效能所在，但如何有效为己所用，还存有大小不一的短板。
      </p>
      <p class="ArticleNormal">
        这导致一些城市的营销离目标受众较远，投入较大但实际效果不明显。在新技术、新渠道、新营销已是必争之域的当下，城市营销已进入一个新的竞争场域，城市借势、造势能力不一，也带来彼此品牌声量强弱不一。
      </p>
      <img src="../../../assets/1st/Articles/Article_12/contant_2.jpg"/>
      <p class="ArticleNormal">
        说到城市品牌营销内容，可发现不少城市多基于官方的话题体系或城市概念来宣传，比如宜居城市、旅游城市等标签，整体偏宏大或宏观叙事，市场辨识度不够高，所呈现的城市“温度”（比如文化温度）不够，且欠缺触动或打动人心的独特内容或单核“爆点”，导致城市营销内容调性相对同质化，难以打造出清晰的城市符号或形象。
      </p>
      <p class="ArticleNormal">
        同时，一些城市或机缘巧合意外爆红，或积极打造营销爆点，但因为优质营销内容的输出能力不够，导致爆点昙花一现，难以内化为持续价值效应。
      </p>
      <p class="ArticleNormal">
        当前的城市营销还有一个存在已久的“痛点”，表现在城市多个单点营销各自出击，但点未串成线，更未组成“面”，导致营销的时间和资金投入不少，但多只产生偏碎片化的效应。背后的主要缘由是招商、文化、旅游等部门基于自身诉求各自营销，对外输出的关键信息不同，城市品牌定位散点化，不够系统聚焦。
      </p>
      <img src="../../../assets/1st/Articles/Article_12/contant_3.jpg"/>
      <p class="ArticleNormal">
        营销作用和品牌声量的非均衡化“痛点”，也较为明显。比如一线城市由于营销意识、可获可用资源以及城市声量等方面，相较于二三线城市，本身即有一定的优势效应，有着更突出更持续的受众牵引力。
      </p>
      <p class="ArticleNormal">
        不过，这一传统营销格局已有较大变化，非一线、非东部城市已频繁“上位”，为什么？
      </p>
      <p class="ArticleNormal">
        而这也可视为城市营销的内容、路径与模式被重构的肇始，又是为何？
      </p>
      <p class="ArticleHead">
        由点到面，重塑城市名片打造路径
      </p>
      <p class="ArticleNormal">
        一个主要缘由是，以抖音为代表的短视频强势介入，重塑了当前的城市营销、城市品牌传播与构建的渠道、路径、模式和价值评估体系。
      </p>
      <p class="ArticleNormal">
        城市营销，正进入新的时代语境中。
      </p>
      <p class="ArticleNormal">
        梳理下来，那些被抖音捧红的城市，首先因为一个或几个差异化内容的短期大量传播，甚至部分裂变，形成热门话题和强关注度，乃至形成一个爆点，进而吸引大量人群前来打卡体验、消费，进一步扩大传播效应，而当地企业、政府部门跟进，一方面保持话题度，另一方面提供更多的体验服务…..形成循环效应。
      </p>
      <p class="ArticleNormal">
        但为何这些背后是抖音？
      </p>
      <p class="ArticleNormal">
        其一，抖音实现了大量年轻用户的高黏性聚集，用户量也还在扩增，这是城市营销必然要去触达且可触达的巨量用户池。
      </p>
      <p class="ArticleNormal">
        其二，抖音的庞大数据体量及数据分析能力，使得较为优质的营销内容可以相对精准的触达用户，带来有效的营销效果，包括提升线下消费落地的概率。城市影响力的打造，基底是城市的各类特质，如何更好的理解用户对城市文化等各类特质的偏好，并产出短视频内容（比如美景美食是抖音用户最希望看到的内容），引发用户的心理共鸣。
      </p>
      <p class="ArticleNormal">
        其三，抖音正聚合更多的文旅营销内容（来自地方政府主管部门、旅游项目或机构、达人等），其间文旅属性也更为突出，这使得城市基于文旅营销的内容或方式，有了更好的可转化率。
      </p>
      <p class="ArticleNormal">
        统观来说，抖音已基于流量、互动、达人、内容与沉淀五个维度，构建了互通循环作用的城市营销闭环体系。五个维度的内在逻辑可概括为：流量与互动相互支撑，互动与达人相互带动；达人与内容相互成就，内容与沉淀相互补充，沉淀与流量相互转化。
      </p>
      <p class="ArticleNormal">
        最终要实现的是，营销种草到消费拔草的良性链路或生态，即持续滚动的优质内容打造与输出（种草）、庞大的用户量及精准触达（种草）、城市的品牌声量与用户消费线下转化（拔草）。
      </p>
      <p class="ArticleNormal">
        以抖音为代表的短视频，展现出新媒介技术、渠道，对城市形象传播、品牌塑造等带来的传播理念的更新，以及传播的组织架构和流程的重构，进而带来城市营销的深度变革，其当前及未来价值，将体现在多个层面。
      </p>
      <p class="ArticleNormal">
        未来，城市品牌的更强更立体塑造，都将是考验对“人”的理解，指向的是“人格化”城市与目标群体的气息契合、心意互通，考验城市营销操盘者上至制定策略，下至打通链接短视频内容与目标客群的能力。
      </p>
      <img src="../../../assets/1st/Articles/Article_12/contant_4.jpg"/>
      <p class="ArticleNormal">
        沿着这个思路，也就不难理解为何有的城市“一瞬间”能成为网红？又为何一些城市网红不过几月，就泯然众人。
      </p>
      <p class="ArticleNormal">
        网红城市有密钥吗？网红如何长青？
      </p>
      <p class="ArticleNormal">
        在上述基础上，城市还要做什么？系统研判本地可通过短视频营销的短视频内容，特色化、独特性等是关键，且要保持连贯持续的内容输出，强化营销作用，提高目标用户注意力的黏性，以及扩增关注用户，忠粉难求，但城市要有自己的“忠粉圈”。
      </p>
      <p class="ArticleNormal">
        关键还在于，说得好，还得做得好，吸引粉丝前来，要让他们“忠心诚意”消费，也就是城市要对应营销内容，打造城市可体验服务，线上展现与线下体验相契合，打通营销链条。
      </p>
      <p class="ArticleNormal">
        在这些情境下，诸如抖音等短视频平台如何应时顺势契合不同区域的城市营销诉求，颇为关键。它们的动作走向，将成为城市营销的一大变量。
      </p>
    </div>
</template>

<script>
    export default {
        name: "Article12"
    }
</script>

<style scoped>
  img{
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/1st/Articles/Article12.vue